import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { createUser } from "../../utils/API"
import SelectCountry from './components/SelectCountry';

class SignUpForm extends Component {

  constructor(props) {
    super(props);
    this.state = { email: '', password: '', firstName: '', lastName: '', country: '', noNewsLetter: false, agreePolicy: false };
    this.handleChangeFormElement = this.handleChangeFormElement.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChangeFormElement(evt) {
    const value = evt.target.value;
    if (evt.target.name === 'agreePolicy' || evt.target.name === 'noNewsLetter') {
      const { checked } = evt.target
      this.setState({ [evt.target.name]: checked });
    } else {
      this.setState({ [evt.target.name]: value });
    }
  }


  handleSubmit(event) {
    event.preventDefault();
    createUser(this.state)
  }
  componentDidMount() {

  }



  render() {
    return (
      <div className="row">
        <div className="col-lg-8 col-md-10 ml-auto mr-auto">
          <div className="register-form text-center">
            <form id="contact-form" onSubmit={this.handleSubmit}>
              <div className="messages" />
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input id="form_name" onChange={this.handleChangeFormElement} type="text" name="firstName" className="form-control" placeholder="Prénom" required="required" data-error="Firstname is required." />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input id="form_lastname" onChange={this.handleChangeFormElement} type="text" name="lastName" className="form-control" placeholder="Nom" required="required" data-error="Lastname is required." />
                    <div className="help-block with-errors" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input id="form_email" type="email" onChange={this.handleChangeFormElement} name="email" className="form-control" placeholder="Email" required="required" data-error="Valid email is required." />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input id="form_password" onChange={this.handleChangeFormElement} type="password" name="password" className="form-control" placeholder="Mot de passe" required="required" data-error="password is required." />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <SelectCountry handleChangeFormElement={this.handleChangeFormElement} />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input id="form_position" onChange={this.handleChangeFormElement} type="text" name="password" className="form-control" placeholder="Position" required="required" data-error="password is required." />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input id="form_company_name" onChange={this.handleChangeFormElement} type="text" name="password" className="form-control" placeholder="Company name" required="required" data-error="password is required." />
                    <div className="help-block with-errors" />
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-md-12">
                  <div className="remember-checkbox clearfix mb-5">
                    <div className="custom-control custom-checkbox">
                      <input required="required" type="checkbox" className="custom-control-input" id="customCheck1" onChange={this.handleChangeFormElement} name='agreePolicy' />
                      <label className="custom-control-label" htmlFor="customCheck1">En continuant votre inscription, vous acceptez nos Conditions Générales.</label>
                    </div>

                    <div className="custom-control custom-checkbox">
                      <input type="checkbox" className="custom-control-input" id="customCheck2" onChange={this.handleChangeFormElement} name='noNewsLetter' />
                      <label className="custom-control-label" htmlFor="customCheck2">Je ne souhaite pas recevoir les nouveautés de Resilience</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary">S'inscrire</button>
                  <span className="mt-4 d-block">J'ai déjà un compte ? <Link to="/login"><i>Me connecter</i></Link></span>
                </div>
              </div>
            </form>
          </div>
        </div >
      </div >

    );
  }
}

export default SignUpForm;